import React from 'react';

function TimeComparisonPopup({ segment, onClose }) {
  if (!segment) return null;

  const { seg_id, refIndex, compIndex, changeDiff, refPeriod, compPeriod } = segment;

  const formatMonth = (yymm) => {
    const monthNames = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const s = String(yymm);
    const yy = parseInt(s.slice(0, 2), 10);
    const mm = parseInt(s.slice(2), 10);
    return `${monthNames[mm - 1]} ${2000 + yy}`;
  };

  const refLabel = refPeriod ? formatMonth(refPeriod) : '-';
  const compLabel = compPeriod ? formatMonth(compPeriod) : '-';

  const change = compIndex - refIndex;
  const changeRate = refIndex !== 0 && compIndex !== 0
    ? (change >= 0 ? '+' : '') + (change / refIndex * 100).toFixed(1)
    : null;

  const changeColor = change > 0 ? '#EF4444' : change < 0 ? '#2563EB' : '#64748b';

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '65%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#ffffff',
        border: '1px solid #cbd5e1',
        borderRadius: '12px',
        padding: '20px',
        zIndex: 1000,
        minWidth: '280px',
        maxWidth: '360px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.05)',
      }}
    >
      {/* ヘッダー */}
      <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h3 style={{ margin: 0, color: '#1e293b', fontSize: '16px', fontWeight: '600' }}>
            Time Comparison
          </h3>
          <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: '12px' }}>
            Segment ID: {seg_id}
          </p>
        </div>
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#64748b',
            fontSize: '24px',
            cursor: 'pointer',
            padding: '0',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(59, 130, 246, 0.1)';
            e.target.style.color = '#2563eb';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
            e.target.style.color = '#64748b';
          }}
        >
          ×
        </button>
      </div>

      {/* 比較データ */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '12px',
        backgroundColor: '#f1f5f9',
        borderRadius: '8px'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ color: '#64748b', fontSize: '12px' }}>Reference Index:</span>
          <span style={{ color: '#1e293b', fontSize: '15px', fontWeight: '600' }}>
            {Math.round(refIndex)} <span style={{ color: '#64748b', fontSize: '11px', fontWeight: '400' }}>({refLabel})</span>
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ color: '#64748b', fontSize: '12px' }}>Comparison Index:</span>
          <span style={{ color: '#1e293b', fontSize: '15px', fontWeight: '600' }}>
            {Math.round(compIndex)} <span style={{ color: '#64748b', fontSize: '11px', fontWeight: '400' }}>({compLabel})</span>
          </span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
          <span style={{ color: '#64748b', fontSize: '12px' }}>Change:</span>
          <span style={{ color: changeColor, fontSize: '15px', fontWeight: '600' }}>
            {change > 0 ? '+' : ''}{Math.round(change)}
          </span>
        </div>
        {changeRate !== null && (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ color: '#64748b', fontSize: '12px' }}>Change Rate:</span>
            <span style={{ color: changeColor, fontSize: '15px', fontWeight: '600' }}>{changeRate}%</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default TimeComparisonPopup;
